import { type MaintenanceChecklistField } from '@gb-ticket/shared-types';

import { Input } from '@/components/ui/input';
import { ChecklistFieldShell } from '@/products/maintenance/features/protocol-renderer/checklist-field-shell';

type AttachmentField = Extract<MaintenanceChecklistField, { type: 'attachment' }>;

type Props = {
  field: AttachmentField;
  readOnly?: boolean;
};

export function ChecklistAttachmentField({ field, readOnly = true }: Props) {
  return (
    <ChecklistFieldShell field={field}>
      <Input type="file" disabled={readOnly} />
    </ChecklistFieldShell>
  );
}
